/**
 * Parsea una fecha de calendario de forma **estable a zona horaria**.
 *
 * Los campos de fecha del evento (p. ej. `wedding_date`, un TIMESTAMPTZ guardado
 * a medianoche UTC porque viene de un date picker date-only) parseados con
 * `new Date(iso)` + getters/format locales corren el día al huso del visitante:
 * `2026-09-05T00:00:00Z` se muestra como 4-sep al oeste de UTC. Tomamos la parte
 * `YYYY-MM-DD` y construimos una fecha **LOCAL**, sin conversión de huso.
 *
 * (Espeja el parseo del render v2 en `src/invitation/payload/derived.ts`; se
 * mantiene aquí como util compartido para el dashboard y componentes v1.)
 */
export function parseCalendarDate(iso: string | null | undefined): Date | null {
  if (!iso) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  const d = new Date(iso);
  return isNaN(d.getTime()) ? null : d;
}
